import { render, staticRenderFns } from "./officialAccount.vue?vue&type=template&id=cae2cdd6&scoped=true"
import script from "./officialAccount.vue?vue&type=script&lang=js"
export * from "./officialAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae2cdd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cae2cdd6')) {
      api.createRecord('cae2cdd6', component.options)
    } else {
      api.reload('cae2cdd6', component.options)
    }
    module.hot.accept("./officialAccount.vue?vue&type=template&id=cae2cdd6&scoped=true", function () {
      api.rerender('cae2cdd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/officialAccount/officialAccount.vue"
export default component.exports